import React from "react";
import moment from "moment";
import { name } from "../config";

function ManagerCampaignView(props) {
  const { campaign, setCampaign, tapes, setBus, setTab } = props;
  const taped = [];
  const removed = [];

  tapes.forEach((cur) => {
    if (cur.campaignId !== campaign.campaignId || cur.format !== campaign.format) return;
    if (cur.removed) removed.push(cur);
    else taped.push(cur);
  });

  const busses = taped.reduce((busses, row) => {
    busses.push(row.busNumber);
    return busses;
  }, []);

  const startDate = moment().isoWeek(campaign.start).day("Monday"); //console.log(startDate);
  let endDate = campaign.end !== "" ? moment().day("Monday").week(campaign.end) : startDate.clone().add(4, "weeks"); //console.log(endDate);
  if (startDate.isAfter(endDate)) endDate.add(1, "year");
  const range = `&start=${startDate.format("YYYY-MM-DD")}&end=${endDate.format("YYYY-MM-DD")}`;
  const heatmapLink = "https://www.slmplanner.fi/bussiheat?busses=" + busses.join() + range;

  //console.log(heatmapLink);

  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          setCampaign(undefined);
        }}
      >
        Takaisin Kampanjalistaan
      </button>
      {busses.length > 0 && name === "PKS" && (
        <a className="buttonlike" href={heatmapLink} rel="noreferrer" target="_blank">
          Heatmap
        </a>
      )}
      <h3 className="campaign-title">{"Kampanjan " + campaign.format + " " + campaign.client + " teipatut mainokset"}</h3>
      {taped.map((el, index) => {
        //console.log(el);
        return (
          <div
            className="bus-entry"
            key={index}
            onClick={() => {
              setBus(el.busNumber);
              setTab("buses");
            }}
          >
            {el.busNumber + (Number(el.amount) > 1 ? ":" + el.amount : "")}
          </div>
        );
      })}
      <h3 className="campaign-title">{"Kampanjan " + campaign.format + " " + campaign.client + " jo poistetut mainokset"}</h3>
      {removed.map((el, index) => {
        //console.log(el);
        return (
          <div
            className="bus-item"
            key={index}
            onClick={() => {
              setBus(el.busNumber);
              setTab("Buses");
            }}
          >
            {el.busNumber + (Number(el.amount) > 1 ? ":" + el.amount : "")}
          </div>
        );
      })}
    </div>
  );
}
export default ManagerCampaignView;
